import { entriesReducerFactory } from '@/fleet-configuration/data-fleet/entries/entries-reducer-factory'
import { SET_CONNECTION, REMOVE_ALL_CONNECTIONS, REMOVE_CONNECTION } from './connections-actions.js'

export const connectionsReducer = entriesReducerFactory(SET_CONNECTION, REMOVE_ALL_CONNECTIONS, REMOVE_CONNECTION)
